/**
 * 下载队列
 */

import { FileChatMessage, VideoChatMessage, ImageChatMessage } from "@/types/chat";
import { DownloadItem, DownloadProgress } from ".";
import DownloadService from "@/server/DownloadService";

export interface SaveOption {
  viewFile: boolean;
  saveAs: boolean;
  message?: any;
  isGroup?: boolean;
  auto?: boolean;
  alreadySaveAs?: boolean;
  isMergeForward?: boolean;
  originMessage?: any;
  [key: string]: any;
}

export interface DownloadOption {
  onStarted: (downloadItem: DownloadItem) => void;
  onProgress: (progress: DownloadProgress) => void;
  onCancel: (alreadySaveAs?: boolean) => void;
  onPause?: () => void;
  onResume?: () => void;
  onFinish: (file: { path: string; filename: string }, data: any) => void;
  onError?: (error: any) => void;
}

interface QueueItemp {
  data: FileChatMessage | VideoChatMessage | ImageChatMessage;
  dowanload: (options: SaveOption) => Promise<void>;
  resolve?: (value?: any) => void;
  reject?: (reason?: unknown) => void;
}

class DownloadFileQueue {
  static donwloadServiceInstance: DownloadService;
  private static instance: DownloadFileQueue | null;
  // 下载队列

  public static getInstance(): DownloadFileQueue {
    if (!this.instance) {
      this.instance = new DownloadFileQueue();
      DownloadFileQueue.donwloadServiceInstance = DownloadService.getInstance({});
    }
    return this.instance;
  }

  private currTask: QueueItemp | null = null;
  private queueItem: QueueItemp[] = [];
  private working = false;
  private downloadedTaskIdMap: Map<string, 1> = new Map();

  /**
   * 增加下载任务
   * @param item
   */
  public pushQueue(item: QueueItemp): void {
    // 兼容合并转发
    const id = (item.data as any).imageId || item.data.mid || (item.data as any).muuid;
    const saveOption = DownloadFileQueue.donwloadServiceInstance.getSaveOption(id);
    const idx = this.queueItem.findIndex(
      (i: QueueItemp) =>
        (i.data as any).imageId === id || i.data.mid === id || (i.data as any).muuid === id
    );
    if (
      (!this.currTask ||
        this.currTask.data.mid !== id ||
        (this.currTask.data as any).muuid !== id) &&
      !saveOption &&
      idx === -1 &&
      !this.downloadedTaskIdMap.has(id)
    ) {
      this.queueItem.unshift(item);
      this.downloadedTaskIdMap.set(id, 1);
    }
    this.consumer();
  }

  /**
   * 删除下载任务
   * @param item
   */
  public delQueue(mid: number): void {
    const idx = this.queueItem.findIndex((i: QueueItemp) => i.data.mid === mid);
    if (idx > -1) {
      this.queueItem.splice(idx, 1);
    }
  }

  /**
   * 清空下载队列
   */
  public clearQueue(): void {
    this.queueItem = [];
    this.currTask = null;
    this.working = false;
    this.downloadedTaskIdMap.clear();
  }

  private async consumer(): Promise<void> {
    if (!this.working) {
      const item = this.queueItem.pop();
      if (item) {
        this.working = true;
        this.currTask = item;
        const { data, dowanload, resolve, reject } = item;
        const saveOption = DownloadFileQueue.donwloadServiceInstance.getSaveOption(
          item.data.mid || (item.data as any).muuid
        );
        // 如果正在手动下载，跳过当前文件的自动下载，执行下一个文件自动下载
        if (saveOption) {
          this.working = false;
          this.currTask = null;
          resolve?.(true);
          this.consumer();
        } else {
          dowanload({ message: data, viewFile: false, saveAs: false, auto: true })
            .then((res) => {
              this.working = false;
              this.currTask = null;
              resolve?.(res);
              this.consumer();
            })
            .catch((err) => {
              this.working = false;
              this.currTask = null;
              reject?.(err);
              console.log(`auto download error`, err);
              this.consumer();
            });
        }
      } else {
        this.working = false;
      }
    } else {
      this.working = false;
    }
  }
}
export default DownloadFileQueue;
